import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, query, orderBy, updateDoc, doc } from "firebase/firestore";
import { saveAs } from "file-saver";

export default function DashboardHome() {
  const [count, setCount] = useState(0);
  const [latest, setLatest] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "feedback"), orderBy("date", "desc"));
      const snapshot = await getDocs(q);
      const unexported = snapshot.docs.filter(doc => !doc.data().exported);
      setCount(unexported.length);
      if (unexported.length > 0) {
        setLatest(unexported[0].data().date.toDate().toLocaleString());
      }
    };
    fetchData();
  }, []);

  const exportToCSV = async () => {
    const q = query(collection(db, "feedback"), orderBy("date", "desc"));
    const snapshot = await getDocs(q);
    const unexported = snapshot.docs.filter(doc => !doc.data().exported);

    const rows = unexported.map(doc => doc.data());
    const header = "text,originalCategory,correctedCategory,date\n";
    const csv =
      header +
      rows
        .map(r =>
          [
            `"${r.text}"`,
            r.originalCategory,
            r.correctedCategory,
            new Date(r.date.seconds * 1000).toISOString()
          ].join(",")
        )
        .join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    saveAs(blob, "feedback_export.csv");

    for (const docRef of unexported) {
      await updateDoc(doc(db, "feedback", docRef.id), { exported: true });
    }
    alert("Feedback exporterad och markerad som hanterad.");
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>Adminöversikt</h1>
      <p>Antal nya feedbackposter: <strong>{count}</strong></p>
      {latest && <p>Senaste inskickat: {latest}</p>}
      <button onClick={exportToCSV} style={{ marginTop: 16 }}>
        Exportera feedback som CSV
      </button>
    </div>
  );
}